// extracted by mini-css-extract-plugin
export default {"IconButton":"kfp_4ons","black":"C3_Blelb","red":"gdCbTBAb","green":"fbNFEAnb","yellow":"qDMrLy8y","xs":"e9oSY7F_","s":"rJUBxBEY","m":"qFUsnSKe","l":"RKKELq3d"};